// The operator manuals: one per Backoffice surface that needs more than a
// tooltip - how to give a customer access, and the three data clean-up
// worklists. Published to the public assets bucket (tools/manuals), so a
// manual opens without a Backoffice session; sales reads them on a phone
// too. The licensing manual is the former operator playbook, HTML; the
// clean-up manuals are PDFs built from tools/manuals. An updated manual is
// uploaded under the same name and its CDN path purged (the publish steps
// in tools/manuals/README.md), so these URLs are stable.
export type ManualKey =
  | "licensing"
  | "customerMismatches"
  | "duplicateEmails"
  | "crmMerges"

export type Manual = {
  /** The button's label. */
  label: string
  url: string
  /** The hover text: what the manual answers. */
  title: string
  /** The FeatureCode of the way into this manual (tracking, selectors). */
  featureCode: string
}

export const MANUALS: Record<ManualKey, Manual> = {
  licensing: {
    label: "Licensing manual",
    url: "https://assets.placepoint.no/misc/operator-playbook-licensing.html",
    title:
      "How to give a customer access, limit it to named people and read what they get. Opens the licensing manual in a new tab.",
    featureCode: "UI_BackofficeLicensing_Manual_Open",
  },
  customerMismatches: {
    label: "Mismatch manual",
    url: "https://assets.placepoint.no/misc/manual-customer-mismatches.pdf",
    title:
      "Why a user can sit in a team of another customer, how to read the row, and which of the two moves to make. Opens the manual in a new tab.",
    featureCode: "UI_BackofficeUser_MismatchManual_Open",
  },
  duplicateEmails: {
    label: "Duplicates manual",
    url: "https://assets.placepoint.no/misc/manual-duplicate-emails.pdf",
    title:
      "How one person ended up with two user rows, which row to keep, and what Keep this one moves. Opens the manual in a new tab.",
    featureCode: "UI_BackofficeUser_DuplicateManual_Open",
  },
  crmMerges: {
    label: "Merge manual",
    url: "https://assets.placepoint.no/misc/manual-crm-merges.pdf",
    title:
      "What a HubSpot company merge leaves behind, what the Backoffice does about it on its own, and what a person decides. Opens the manual in a new tab.",
    featureCode: "UI_BackofficeCustomer_MergeManual_Open",
  },
}
